import { Controller } from "@hotwired/stimulus";
import { useClickOutside } from "stimulus-use";

export default class extends Controller {
  static targets = ["value", "options", "placeholder"]

  connect() {
    useClickOutside(this)
  }

  toggleDropdown() {
    this.element.classList.toggle('dropdown--active')
  }

  setValue(e) {
    if (e.params) {
      this.valueTarget.value = e.params.value;
      this.valueTarget.dispatchEvent(new Event("change"));
    }

    this.optionsTarget.querySelectorAll('li').forEach(option =>
      option.classList.remove('dropdown__option--selected'
    ));

    e.target.classList.add('dropdown__option--selected');
    this.placeholderTarget.innerText = e.target.innerText
  }

  clickOutside() {
    this.element.classList.remove('dropdown--active')
  }
}